import { LEARN_AUDIO, LearnDetails } from '../types';

const learnInitialState: LearnDetails = {
  learnAudio: undefined,
};

export default function learnReducer(state = learnInitialState, action): LearnDetails {
  switch (action.type) {
    case LEARN_AUDIO:
      return {
        learnAudio: action.payload,
      };
    default:
      return state;
  }
}
